module.exports = __webpack_public_path__ + "static/media/dashboard_icon.c9b68b13.svg";